import React, { useState } from "react";
import ReactDOM from 'react-dom';
import "./Resultpage.css";
import jocker from '../Assets/JOKER.png'

const Result = ({ onClose, resultData }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const closePopup = () => {
        onClose(false);
    };

    const sumDigits = (num) => num.split("").reduce((sum, digit) => sum + parseInt(digit), 0);

    const modal = (
        <div className="popup-overlay" role="dialog" aria-modal="true">
            <div className="popup-container">
                    <button className="close-btn" onClick={closePopup}>
                        &times;
                    </button>
                    <h1>Results</h1>
                    {loading && <p>Loading...</p>}
                    {error && <p className="error-message">{error}</p>}
                    {!loading && !error && (
                        <div className="results-grid">
                            {resultData.length > 0 ? (
                                resultData.map((result, index) => {
                                    const sessionTime = new Date(`2025-03-10T${result.session_time}`).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    });

                                    return (
                                        <div
                                            key={index}
                                            className={`result-card ${result.is_jocker ? "jocker-card" : ""}`}
                                        >
                                            <div className="session-time">{sessionTime}</div>

                                            <p className="winning-number">{result.product_number}</p>

                                            <p className="single-winning-number">
                                                {sumDigits(result.product_number) % 10}
                                            </p>

                                            <div className="jocker-status">
                                                {result.is_jocker ? (
                                                    <img src={jocker} style={{ height: "60px", width: "85px" }} alt='jocker' />
                                                ) : (
                                                    <span className="jocker-false">No Jocker</span>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <p className="no-results">No results available.</p>
                            )}
                        </div>

                    )}
                </div>
            </div>
    );

    return ReactDOM.createPortal(modal, document.body);
};

export default Result;
